import { deepMerge } from 'js/utils/Utils'
import { PlaneGeometry } from 'three'
import BgXLPlaneMesh from 'js/webgl/customMeshes/BgXLPlaneMesh'
import SlideshowAPlaneMesh from 'js/webgl/customMeshes/SlideshowAPlaneMesh'
import BgColorPlaneMesh from 'js/webgl/customMeshes/BgColorPlaneMesh'
import ListThumbAPlaneMesh from 'js/webgl/customMeshes/ListThumbAPlaneMesh'
import ListThumbBPlaneMesh from 'js/webgl/customMeshes/ListThumbBPlaneMesh'

const defaults = {
  instanceName: 'homeWebgl',
  $names: {
    bgXL: '[data-gl-item="bg-xl"]',
    bg: '[data-gl-item="bg"]',
    slideshowA: '[data-gl-item="slideshow-a"]',
    listThumbA: '[data-gl-item="list-thumb-a"]',
    listThumbB: '[data-gl-item="list-thumb-b"]',
  },
  dataNames: {},
}

export default class HomeWebgl {
  $contentRoot = document
  $bgXLs = []
  $bgs = []
  $slideshowAs = []
  $listThumbAs = []
  $listThumbBs = []
  meshesItems = []

  bgXLMeshes = []
  bgMeshes = []
  slideshowAMeshes = []
  listThumbAMeshes = []
  listThumbBMeshes = []
  originalPlaneGeometry = null

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._setMeshes()
    this._addEventListeners()
    this._addGUI()
  }

  destroy() {
    this._removeGUI()
    this._removeEventListeners()
    this._clearMesh()
  }

  _set$() {
    this.$bgXLs = this.$contentRoot.querySelectorAll(this.$names.bgXL)
    this.$bgs = this.$contentRoot.querySelectorAll(this.$names.bg)
    this.$slideshowAs = this.$contentRoot.querySelectorAll(this.$names.slideshowA)
    this.$listThumbAs = this.$contentRoot.querySelectorAll(this.$names.listThumbA)
    this.$listThumbBs = this.$contentRoot.querySelectorAll(this.$names.listThumbB)
  }

  _setMeshes() {
    this.meshesItems = []
    this.originalPlaneGeometry = new PlaneGeometry(1, 1, 1, 1)
    this.bgXLMeshes = []
    this.$bgXLs.forEach(($bgXL, i) => {
      this.bgXLMeshes[i] = new BgXLPlaneMesh({
        webgl: this,
        $target: $bgXL,
        isFV: i === 0,
        geometry: this.originalPlaneGeometry,
        instanceName: `homeWebgl-bgXL-${i}`,
        index: i,
      })
    })

    this.bgMeshes = []
    this.$bgs.forEach(($bg, i) => {
      this.bgMeshes[i] = new BgColorPlaneMesh({
        webgl: this,
        $target: $bg,
        geometry: this.originalPlaneGeometry,
        instanceName: `homeWebgl-bg-${i}`,
        index: i,
      })
    })

    this.slideshowAMeshes = []
    this.$slideshowAs.forEach(($slideshowA, i) => {
      this.slideshowAMeshes[i] = new SlideshowAPlaneMesh({
        webgl: this,
        $target: $slideshowA,
        geometry: this.originalPlaneGeometry,
        instanceName: `homeWebgl-slideshowA-${i}`,
        index: i,
      })
    })

    this.listThumbAMeshes = []
    this.$listThumbAs.forEach(($listThumbA, i) => {
      this.listThumbAMeshes[i] = new ListThumbAPlaneMesh({
        webgl: this,
        $target: $listThumbA,
        geometry: this.originalPlaneGeometry,
        instanceName: `homeWebgl-listThumbA-${i}`,
        index: i,
      })
    })

    this.listThumbBMeshes = []
    this.$listThumbBs.forEach(($listThumbB, i) => {
      this.listThumbBMeshes[i] = new ListThumbBPlaneMesh({
        webgl: this,
        $target: $listThumbB,
        geometry: this.originalPlaneGeometry,
        instanceName: `homeWebgl-listThumbB-${i}`,
        index: i,
      })
    })

    this.meshesItems.push(this.bgXLMeshes)
    this.meshesItems.push(this.bgMeshes)
    this.meshesItems.push(this.slideshowAMeshes)
    this.meshesItems.push(this.listThumbAMeshes)
    this.meshesItems.push(this.listThumbBMeshes)

    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.init()
      })
    })

    if (this.originalPlaneGeometry) {
      this.originalPlaneGeometry.dispose()
      this.originalPlaneGeometry = null
    }
  }

  _clearMesh() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.destroy()
        mesh = null
      })
    })
    this.meshesItems = []
  }

  _addEventListeners() {}

  _removeEventListeners() {}

  fvAnimation() {
    this.bgXLMeshes[0]?.fvAnimation()
  }

  onResize() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.onResize()
      })
    })
  }

  onRaf() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.onRaf()
      })
    })
  }

  _addGUI() {
    // const meshes = []
    // meshes.forEach((mesh) => {
    //   if (mesh && mesh._addGUI) {
    //     mesh._addGUI()
    //   }
    // })
  }

  _removeGUI() {
    // this.meshesItems.forEach((meshesItem) => {
    //   meshesItem.forEach((mesh) => {
    //     mesh._removeGUI()
    //   })
    // })
  }
}